import { MAX_INVOICE_PRICE_AMOUNT } from '../constants/invoice-price-constant'

export const formatNumber = (inputValue: any, decimalPlaces = 2): string => {
  if (isNaN(inputValue)) return 'NaN'

  const formattedNumber = Number(inputValue)
  return formattedNumber.toFixed(decimalPlaces)
}

export var countDecimals = function (value: number) {
  if (value % 1 != 0) return value.toString().split('.')[1].length
  return 0
}

export const handleInvoicePriceAmountChange = (event: any, setValue: (v: any) => void) => {
  if (!isNaN(event.value) && event.value <= MAX_INVOICE_PRICE_AMOUNT) {
    setValue(event.value)
  }
}
